/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum ProductCategorizationTypeEnum {
    CHANGE_MASTER_CATEGORIZATION = 'CHANGE_MASTER_CATEGORIZATION',
    REPLACE_MASTER_CATEGORIZATION = 'REPLACE_MASTER_CATEGORIZATION',
}